import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import SYSTEM_DEFICIT from 'common/constants/inventoryLabels';
import { formatQty } from '../utils/bulkLotNdcStatus';
import { warningTextTone } from '../utils/warningTone';

/**
 * The two lines that sit between the filter bar and the grid.
 *
 * Their own file because BulkLotNdcReviewDialog is at the 450-line cap, and because they answer
 * the same question at two scales: what is on screen, and what the batch is about to record.
 */
const BulkLotNdcReviewCaptions = ({
  shownCount,
  listedCount,
  autoIncludedCount,
  unverifiedQty,
}) => (
  <>
    <Typography variant='caption' color='text.secondary' component='div' sx={{ mb: 1 }}>
      {`Showing ${shownCount} of ${listedCount} · ${autoIncludedCount} auto-included · Most urgent first · Your changes are kept when filters change.`}
    </Typography>

    {/* POM-6121 — the batch figure, stated rather than asked. Each row's claim was confirmed when
        it was made; asking again here would re-open decisions taken several rows ago.

        "At least", because it is a floor and not a total. Each picker reads the one availability
        snapshot the review opened with, so two rows claiming against the SAME lot both see its
        full balance: the first row's claim is counted here, the second row is never told it is
        short and contributes nothing to this number. The commit re-validates and reports what
        actually happened — the long-standing trade-off for editing a batch against one snapshot
        — so the honest thing here is a lower bound. */}
    {unverifiedQty > 0 && (
      <Typography variant='caption' component='div' sx={{ mb: 1, color: warningTextTone }}>
        {`At least ${formatQty(unverifiedQty)} units across this batch will be claimed as `}
        {SYSTEM_DEFICIT.toLowerCase()} — stock dispensed but not yet received into inventory.
      </Typography>
    )}
  </>
);

BulkLotNdcReviewCaptions.propTypes = {
  shownCount: PropTypes.number,
  listedCount: PropTypes.number,
  autoIncludedCount: PropTypes.number,
  unverifiedQty: PropTypes.number,
};

BulkLotNdcReviewCaptions.defaultProps = {
  shownCount: 0,
  listedCount: 0,
  autoIncludedCount: 0,
  unverifiedQty: 0,
};

export default BulkLotNdcReviewCaptions;
